import React from "react";
import { Col, Row } from "react-bootstrap";
import { Button, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import './BackNext.scss'

export default function BackNext(props) {

  const { continueLabel, hideBack, disabled, loading, onBack, hide, isAflac, colSize, width } = props;

  const label = continueLabel || { text: 'Continue' };

  const aflac = isAflac || false;

  if (loading) {
    return <div className="justify-content-center mt-5 mb-2 text-center"><CircularProgress /></div>;
  }

  return (
    <Row className={hide ? 'd-none' : label.text === 'Contact Our Team' ? 'g-0-rows' : colSize ? 'justify-content-between mt-3' : ''}>
      <Col lg={colSize} className={`${hideBack ? 'd-none' : label.text === 'Contact Our Team' ? 'right-margin' : aflac ? 'btn-back-alignment' : ''} ${width ? `w-${width}` : ''}`}>
        <div className={`${aflac ? '' : 'mb-3'} form-group`}>
          <Button disabled={disabled || loading} variant="outlined" color="primary" onClick={onBack} fullWidth className={aflac ? 'btn-back' : ''}>Back</Button>
        </div>
      </Col>
      <Col lg={colSize} className={`${label.text === 'Contact Our Team' ? 'left-margin' : aflac ? 'btn-next-alignment' : ''} ${width ? `w-${width}` : ''}`}>
        <div className={`${aflac ? '' : 'd-flex m-0'} form-group`}>
          <Button disabled={disabled || loading || props.nextDisabled} type="submit" variant="contained" color="primary" fullWidth className={label.text === 'Contact Our Team' ? 'padding' : `${aflac ? 'btn-back' : ''} submit-button ${props.className || ''}`}>{label.icon} {label.text}</Button>
        </div>
      </Col>
    </Row>
  )
}

BackNext.propTypes = {
  hide: PropTypes.bool,
  onBack: PropTypes.func,
  hideBack: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  continueLabel: PropTypes.object,
  className: PropTypes.string,
  nextDisabled: PropTypes.bool,
}
